import { Button } from 'shadcn/components/ui/Button';
import { Checkbox } from 'shadcn/components/ui/Checkbox';
import { DialogFooter } from 'shadcn/components/ui/Dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'shadcn/components/ui/Table';

/**
 * Displays a table of slices for selection during the duplication process.
 * Users can select/deselect slices by clicking on table rows, which describe slice details.
 *
 * @param {Function} onCancel - Callback function called when the cancel button is clicked
 * @param {Function} onContinue - Callback function called when the continue button is clicked
 * @param {Array} selectedSlices - Array of currently selected slice objects
 * @param {Array} slices - Array of all available slice objects to display
 * @param {Function} toggleSlice - Callback function to toggle selection state of a slice
 */
export default function SliceSelectionStep({ onCancel, onContinue, selectedSlices, slices, toggleSlice }) {
    const isSliceSelected = (sliceId) => selectedSlices.some((s) => s.id === sliceId);

    return (
        <>
            <div className="flex flex-col overflow-auto">
                <h3 className="p-2 font-bold text-md rounded-t-md border border-b-0 bg-muted">Selected Slices</h3>
                <Table className="flex-1 border rounded-md rounded-t-none overflow-auto">
                    <TableHeader className="sticky top-0 bg-background z-10">
                        <TableRow>
                            <TableHead />
                            <TableHead>Rank</TableHead>
                            <TableHead>ID</TableHead>
                            <TableHead>Name</TableHead>
                            <TableHead>Type</TableHead>
                            <TableHead className="text-center">Valid</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {slices.map((slice, index) => (
                            <TableRow key={slice.id} onClick={() => toggleSlice(slice)} className="cursor-pointer">
                                <TableCell>
                                    <Checkbox id={slice.id} checked={isSliceSelected(slice.id)} readOnly />
                                </TableCell>
                                <TableCell>{index}</TableCell>
                                <TableCell>
                                    {slice.id.toString().includes('temp-') ? <StyledNone /> : slice.id}
                                </TableCell>
                                <TableCell>{slice.name || <StyledNone />}</TableCell>
                                <TableCell>{slice.displayType}</TableCell>
                                <TableCell>
                                    <div className="flex justify-center">
                                        <ValidityIndicator valid={slice.valid} />
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
            <DialogFooter className="flex items-center sm:justify-between mt-4">
                <p className="text-sm text-muted-foreground">{selectedSlices.length} slices selected</p>
                <div className="flex items-center gap-2">
                    <Button onClick={onCancel} variant="outline">
                        Cancel
                    </Button>
                    <Button disabled={selectedSlices.length === 0} onClick={onContinue}>
                        Continue
                    </Button>
                </div>
            </DialogFooter>
        </>
    );
}

function StyledNone() {
    return <span className="text-muted-foreground italic">None</span>;
}

function ValidityIndicator({ valid }) {
    return valid ? (
        <div className="size-1.5 rounded-full bg-green-500" />
    ) : (
        <div className="size-1.5 rounded-full bg-red-500" />
    );
}
